<template>
	<div class="page_bg_cover page_shadow">
	</div>
</template>
<script>
export default {
	name: 'page_bg_cover',
	components: {  },
    props: [],
    data() {
        return {
        }
    },
    watch: {
    },
    created() {

    },
    mounted() {
    },
    methods: {
    	
    },
}
</script>
<style type="text/css" lang='less' scoped>
	@import './report.less';
	.page_bg_cover {
		background: url(~@/assets/report_imgs/page_bg_cover.png);
	}
</style>
